import Product from "@system/config/product";
import System from "src/helper/system";
import Api from "src/service/APIHandler";

const API = new Api({});

class ProductInventoryPriceAPICall {

    getAvnetInventory = async (params) => {
        let res = {};
        let reqData = { data: params }

        await API.post(Product.PRODUCT_INVENTORY_AVNET, reqData).then((resHer) => {
            if (resHer.data) {
                res = resHer.data
            }
        });
        return res;
    }

    getNewarcInventory = async (params) => {
        let res = {};
        let url = `${Product.PRODUCT_INVENTORY_NEWARC}/${params}`

        await API.post(url, {}).then((resHer) => {
            if (resHer.data) {
                res = resHer.data
            }
        });
        return res;
    }

    getPricingList = async (params = [], currency = window.mct) => {
        let res = {};
        let param = {};
        param.data = { "lineItems": params, "shipToCustAccNum": System.getUserShippingAddress(), requestedCurrency: currency }
        await API.post(Product.PRODUCT_PRICING_LIST, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data.data.text;
            }
        });

        return res
    };

    getExchangeRate = async (params) => {
        let res = {};

        let param = {}
        param.data = params
        await API.post(Product.CURRENCY_CONVERSION, param).then((resHer) => {
            if (resHer?.data?.data) {
                res = resHer.data?.data || {}
            }
        });
        return res
    }
}

export default ProductInventoryPriceAPICall;